module.exports = __webpack_public_path__ + "static/media/SISTEMA_INTEGRADO.8cd200e9.jpg";